const DB_NAME = 'ib-application-draft';
const STORE_NAME = 'drafts';
const getDraftKey = userId => `user:${userId}`;
const getFallbackKey = userId => `ib-application-draft-data:${userId}`;

const openDatabase = () =>
  new Promise((resolve, reject) => {
    if (!window.indexedDB) {
      reject(new Error('IndexedDB is not available'));
      return;
    }
    const request = window.indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = event => {
      event.target.result.createObjectStore(STORE_NAME, { keyPath: 'id' });
    };
    request.onsuccess = event => resolve(event.target.result);
    request.onerror = () => reject(request.error);
  });

const transactionRequest = (database, mode, action) =>
  new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, mode);
    const request = action(transaction.objectStore(STORE_NAME));
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

export const saveIBDraft = async ({ userId, description, language, attachments }) => {
  if (!userId) return;
  const record = { id: getDraftKey(userId), description, language, attachments };
  try {
    const database = await openDatabase();
    await transactionRequest(database, 'readwrite', store => store.put(record));
    database.close();
  } catch (error) {
    window.localStorage.setItem(getFallbackKey(userId), JSON.stringify({ description, language }));
  }
};

export const loadIBDraft = async userId => {
  if (!userId) return null;
  try {
    const database = await openDatabase();
    const record = await transactionRequest(database, 'readonly', store => store.get(getDraftKey(userId)));
    database.close();
    if (record) return record;
  } catch (error) {
    // Fall through to localStorage for browsers without IndexedDB.
  }
  try {
    const fallback = window.localStorage.getItem(getFallbackKey(userId));
    return fallback ? { ...JSON.parse(fallback), attachments: [] } : null;
  } catch (error) {
    return null;
  }
};

export const clearIBDraft = async userId => {
  if (!userId) return;
  window.localStorage.removeItem(getFallbackKey(userId));
  try {
    const database = await openDatabase();
    await transactionRequest(database, 'readwrite', store => store.delete(getDraftKey(userId)));
    database.close();
  } catch (error) {
    // Nothing else to clear.
  }
};
